export const environment = {
  apiUrl: 'https://5ne3qhx4y8.execute-api.us-west-2.amazonaws.com/gfx-core-staging/api/v1',
  newApiUrl: 'https://stg.api.gfxco.com',
  editorUrl: 'https://gfx-editor-staging-best-apps.vercel.app',
  production: false,
  env: 'staging',
};
